<script>
  import { Link } from 'svelte-routing';
  
  export let currentPath = '/';
</script>

<nav class="bg-gray-900 border-b border-gray-800 sticky top-0 z-50">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex items-center justify-between h-16">
      <div class="flex items-center">
        <Link to="/home" class="text-2xl font-bold text-primary-600">
          AnimeHub
        </Link>
      </div>
      
      <div class="flex space-x-4">
        <Link 
          to="/home" 
          class="px-3 py-2 rounded-md text-sm font-medium transition-colors {currentPath === '/home' ? 'bg-gray-800 text-white' : 'text-gray-300 hover:bg-gray-800 hover:text-white'}"
        >
          Home
        </Link>
        <Link 
          to="/me" 
          class="px-3 py-2 rounded-md text-sm font-medium transition-colors {currentPath === '/me' ? 'bg-gray-800 text-white' : 'text-gray-300 hover:bg-gray-800 hover:text-white'}"
        >
          Admin
        </Link>
      </div>
    </div>
  </div>
</nav>
